import { CommonMessage } from '@frontend/lang';
import { UserSelectV2 } from '@frontend/user/select';
import { User } from '@frontend/user/utils';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import usePickUpBy from './pick-up-by.controller';

const ID = 'pick-up-by';

const PickUpBy = () => {
    const viewProps = usePickUpBy();

    return (
        <WizardScreenContainer
            id={ID}
            header={{ title: CommonMessage.BUTTONS.PICK_UP }}
            footer={{
                onSubmit: viewProps.onSubmit,
                submitDisabled: viewProps.submitDisabled
            }}
            containerClassName='flex flex-1 flex-col items-start justify-start gap-3 self-stretch px-5 pt-6 pb-20'>
            <div className='flex items-start justify-start self-stretch'>
                <div className='text-foreground-default justify-start text-base font-medium'>
                    <FormattedMessage
                        defaultMessage='Please search for your name in the list'
                        description='Instruction to pick your name from the list'
                        id='kiosk.wizard.pick-up-by.instruction'
                    />
                </div>
            </div>
            <UserSelectV2
                hideLabel
                value={viewProps.pickedUpBy}
                onChange={viewProps.setPickedUpBy}
                isClearable
                customLabel={(user) => new User(user).getDisplayName()}
                minSearchCharacters={3}
            />

            {viewProps.comments && (
                <>
                    <div className='inline-flex items-center justify-between self-stretch'>
                        <div className='text-foreground-default justify-start text-center text-base font-medium'>
                            {CommonMessage.OBJECTS.TRANSACTION.COMMENTS}
                        </div>
                    </div>
                    <div
                        data-state='Open'
                        className='bg-background-surface inline-flex flex-col items-start justify-start gap-5 self-stretch rounded-xl p-4'>
                        <div className='inline-flex items-center justify-between self-stretch'>
                            <div className='flex items-center justify-start gap-4'>{viewProps.comments}</div>
                        </div>
                    </div>
                </>
            )}
        </WizardScreenContainer>
    );
};

export default PickUpBy;
